// extracted by mini-css-extract-plugin
module.exports = {"accessoriesH5":"accessories_accessoriesH5__XKXXq"};